import $ from 'jquery';
import _ from 'lodash';

// Gets Input name and value for parsing data via ajax
export function getInputNameAndValue(input) {
    var getLastChunkOfInputName = function (name) {
        name = name + '';
        var chunks = [];
        var parts = name.split('[');
        for ( var i = 0; i < parts.length; i++ ) {
            var part = parts[ i ];
            if (part.substr(-1) === ']') {
                part = part.substr(0, part.length - 1);
                chunks.push(part);
            }
        }

        return chunks.pop();
    }

    var item = $(input);
    var type = item.prop('type');
    var name = '_filter[' + getLastChunkOfInputName(item.attr('name')) + ']';
    var nodeName = input.nodeName.toLowerCase();
    var value = null;

    // Detect value and name:
    if (nodeName === 'select' && item.prop('multiple')) {
        if (item.val() instanceof Array && item.val().length > 0) {
            value = item.val();
        }
        name = '_filter[' + item.attr('name').replace('[]', '') + ']';
    } else
        if ((type === 'checkbox' || type === 'radio')) {
            if (item.prop('checked')) {
                value = item.val();
            }
        } else {
            value = '' + item.val();
        }

    return {
        name: name,
        value: value
    }
};

export function reDrawTableOnFilterInputEvent(element, table) {

    var _refreshTable = function () {
        table.draw();
    };
    if (element.type === 'text') {
        clearTimeout(typingTimer);
        typingTimer = setTimeout(_refreshTable, ajaxSearchDelay);
    } else {
        _refreshTable();
    }
};

export function setCheckboxOn($element) {
    $element.prop('checked', true).attr('checked', 'checked');
}

export function setCheckboxOff($element) {
    $element.prop('checked', false).attr('checked', false);
}

export function handleCheckboxesOn($element) {
    setCheckboxOn($element);
    $element.closest('tr').addClass('selected-row');
}

export function handleCheckboxesOff($element) {
    setCheckboxOff($element);
    $element.closest('tr').removeClass('selected-row');
}

export function getAllRowsFromArray(array, tableName) {
    let arrayOfElements = [];
    array.forEach(function (id) {
        let currentElement = $(`#${tableName}_row_${id}`);
        arrayOfElements.push(currentElement);
    });
    return arrayOfElements;
}

export function checkArraySize(array) {
    array.length < 2 ? hideOptions() : showOptions();
}

export function hideOptions() {
    if (!$('.js-table-tools').hasClass('hidden-tools')) {
        $('.js-table-tools').addClass('hidden-tools');
        // sets Padding top to 0 in case of positioned fixed toolbar
        $('.table-scroll-wrap').css({ 'padding-top': 0 })
    }
}

export function showOptions() {
    if ($('.js-table-tools').hasClass('hidden-tools')) {
        $('.js-table-tools').removeClass('hidden-tools');
    }
}

export function setToActive($table_name) {
    let HIDDEN_TOOLS = 'hidden-tools', SCROLLING = 'scrolling';
    let lastPosition = undefined;
    let tableString = `.js-table-tools[data-table-id="${$table_name}"]`,
        $tableTools = $(tableString);
    
    $(window).on('scroll', _.throttle(function () {
        if ($tableTools.length) {
            if (!$tableTools.hasClass(HIDDEN_TOOLS)) {

                let tableTopPosition = $tableTools.offset().top;
                if (lastPosition === undefined) {
                    if ($(window).scrollTop() >= tableTopPosition) {
                        if (!$tableTools.hasClass(SCROLLING)) {
                            handleScrollingUnderOffset($tableTools, SCROLLING);
                            lastPosition = tableTopPosition;
                        }
                    }
                } else {
                    if ($(window).scrollTop() >= lastPosition) {
                        if (!$tableTools.hasClass(SCROLLING)) {
                            handleScrollingUnderOffset($tableTools, SCROLLING);
                            lastPosition = tableTopPosition;
                        }
                    } else {
                        if ($tableTools.hasClass('scrolling')) {
                            $tableTools.removeClass('scrolling');
                            $tableTools.siblings('.table-scroll-wrap').css({ 'padding-top': '0px' });
                            $tableTools.css({
                                'width': '100%',
                                'left': 'auto'
                            });
                        }
                    }
                }
            }
        }
    }, 100))
};

function handleScrollingUnderOffset($element, scrolling_class) {
    let sideBarWidth = getSidebarWidth();
    $element.css({
        'width': $element.outerWidth(),
        'left': sideBarWidth
    });
    $element.siblings('.table-scroll-wrap').css({ 'padding-top': $element.outerHeight() });
    $element.addClass(scrolling_class);
}

export function fakeScroll() {
    $(window).scroll();
}

function getSidebarWidth() {
    if ($(window).innerWidth() < 1068) {
        return 0
    }
    return $('.sidebar').outerWidth();
}

export function setSelectedWithShift(e) {
    if (e.shiftKey) {
        
    }
}

/**
 * Przenosi paginację tak aby nie była scrollowalna na mobilnych
 */
export function movePagination() {
    const wrapper = $('.table-wrap');

    if (wrapper.length > 0) {
        $('.pagination').insertAfter($('.table-scroll-wrap'));
    }
}

/**
 * Ustawiai zaślepkę gdy w dataTables nie ma żadnych danych
 */
export function setEmptyPlaceholder() {
    const allTables = $("table[id^='listing_table_']");

    $.each(allTables, function () {
        const target = $(this).find('.dataTables_empty');
        const empty = $(this).find('.table__empty--nodata');

        const columns = $(this).find('thead tr').children();
        const colNumber = columns.length;
        const emptyTd = $(this).find('.table__empty--nodata td');
        const searchTd = $(this).find('.table__empty--search td');

        emptyTd.attr('colspan', colNumber);
        searchTd.attr('colspan', colNumber);

        if (target.length > 0) {
            empty.addClass('is-active');
            $(this).addClass('dataTable--nodata');
        } else {
            empty.removeClass('is-active');
        }

    });

}

/**
 * Ustawia w tabeli zaślepkę dla wyników wyszukiwania
 */
export function refreshEmptyPlaceholder() {
    const allTables = $("table[id^='listing_table_']");
    
    $.each(allTables, function () {
        const target = $(this).find('.dataTables_empty');
        const empty = $(this).find('.table__empty--search');

        if (target.length > 0) {
            empty.addClass('is-active');
        } else {
            empty.removeClass('is-active');
        }

    });

}

/**
 * Ustawia w activity-feed zaślepkę na brak aktywności na starcie
 */
export function setEmptyActivityFeed() {
    const activity = $('.c-activity-feed tbody tr');

    if(activity.length == 0) {
        $('#activity-feed').addClass('activity-feed--nodata');
        $('.table__empty').addClass('is-active');
    }

}

/**
 * Ustawia w activity-feed zaślepkę na brak aktywności przy wynikach wyszukiwania
 */
export function setEmptyActivityFeedSearch() {
    const activity = $('.c-activity-feed tbody tr');

    if(activity.length == 0) {
        $('.table__empty--search').addClass('is-active');
    }

}

/**
 * Odswieza datatables
 * @param {Object} table - datatables do odswiezenia
 * @returns {Function} - odświeza tabelkę
 */
export function refreshTable(table) {
    return table.ajax.reload();
}



// WEBPACK FOOTER //
// ./src/_app/components/datatables-helpers.js